module.exports = __webpack_public_path__ + "img/10-1.03193d07.jpg";